<div class="row">
    <div class="col-12 col-md-5 mx-auto p-5">
        <div class="card m-md-4">
            <div class="card-body">
                <ng-container *ngIf="isSuccess">
                    <div class="text-center">
                        <h2 class="fw-bold pt-3 d-flex align-items-center text-center justify-content-center">
                            <i class="material-icons text-primary fs-3">check_circle</i>&nbsp; Password Saved
                        </h2>
                        <div class="text-muted mt-3">
                            Your password has been successfully saved
                        </div>
                        <div class="mt-4">
                            <a [class.disabled]="loading.status" class="btn-link fw-bold text-nowrap" routerLink="/login">
                                Back to login
                            </a>
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="!isSuccess">
                    <div class="d-flex">
                        <div>
                            <div class="p-3">
                                <img [src]="'/assets/logo.png'">
                            </div>
                        </div>
                        <div>
                            <h2 class="fw-bold pt-3">Reset Password</h2>
                            <p class="text-muted">
                                Create new password
                            </p>
                        </div>
                    </div>
                    <form class="p-3 col-12" [formGroup]="theForm" #thisForm="ngForm" (ngSubmit)="submitForm(theForm)" novalidate>
                        <div class="form-floating mb-4 position-relative">
                            <input [type]="showPassword ? 'text' :'password'" formControlName="password" [class.is-invalid]="theForm.get('password')?.invalid && (thisForm.submitted || theForm.get('password')?.touched)" placeholder="New password" class="form-control" required>
                            <button class="btn position-absolute end-0 top-0 h-100 me-3 border-0 outline-0" type="button" (click)="showPassword=!showPassword" tabindex="-1">
                                <i class="material-icons">
                                    {{showPassword ? 'visibility' : 'visibility_off'}}
                                </i>
                            </button>
                            <label>New password</label>
                            <div class="text-danger position-absolute text-end w-100" *ngIf="theForm.get('password')?.invalid && (thisForm.submitted || theForm.get('password')?.touched)">
                                <small *ngIf="theForm.get('password')?.errors?.required">Type password&nbsp;</small>
                                <small *ngIf="theForm.get('password')?.errors?.minlength">Password is at least 6 characters&nbsp;</small>
                                <small *ngIf="theForm.get('password')?.errors?.pattern">Must contain letters, numbers and special characters&nbsp;</small>
                                <small *ngIf="theForm.get('password')?.errors?.serverError">{{theForm.get('password')?.errors?.serverError}}</small>
                            </div>
                        </div>
                        <div class="form-floating mb-4">
                            <input [type]="showPassword ? 'text' :'password'" formControlName="password_confirmation" [class.is-invalid]="theForm.get('password_confirmation')?.invalid && (thisForm.submitted || theForm.get('password_confirmation')?.touched)" placeholder="Repeat new password" class="form-control" required>
                            <label>Repeat new password</label>
                            <div class="text-danger position-absolute text-end w-100" *ngIf="theForm.get('password_confirmation')?.invalid && (thisForm.submitted || theForm.get('password_confirmation')?.touched)">
                                <small *ngIf="theForm.get('password_confirmation')?.errors?.required">Repeat new password&nbsp;</small>
                                <small *ngIf="theForm.get('password_confirmation')?.errors?.passwordMismatch">Password is not same&nbsp;</small>
                                <small *ngIf="theForm.get('password_confirmation')?.errors?.serverError">{{theForm.get('password_confirmation')?.errors?.serverError}}</small>
                            </div>
                        </div>
                        <div class="row d-flex justify-content-between">
                            <div class="col-12">
                                <button type="submit" [attr.disabled]="loading.status?'disabled':null" class="btn btn-primary py-2 px-4 w-100">
                                    Save Password
                                </button>
                            </div>
                        </div>
                    </form>
                </ng-container>
            </div>
        </div>
    </div>
</div>
